"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const core_1 = require("@emotion/core");
const react_1 = require("react");
const input_1 = __importDefault(require("../input"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const TextArea = (_a) => {
    var { helperMessage } = _a, rest = __rest(_a, ["helperMessage"]);
    const { maxLength, className } = rest;
    const [counter, setCounter] = react_1.useState(maxLength ? `0/${maxLength}` : '');
    const onChangeText = (e) => {
        if (!maxLength)
            return;
        const typedText = e.currentTarget.value;
        setCounter(`${typedText.length}/${maxLength}`);
    };
    return (core_1.jsx("div", { className: className },
        core_1.jsx(input_1.default, Object.assign({ type: "text", onInput: onChangeText, multiline: true, numberOfLines: 6 }, rest)),
        core_1.jsx("div", { className: styles_scss_1.default.footerFlexContainer },
            core_1.jsx("p", { className: styles_scss_1.default.helperMessage }, helperMessage),
            core_1.jsx("span", { className: styles_scss_1.default.counter }, counter))));
};
TextArea.defaultProps = {
    maxLength: null,
    helperMessage: '',
};
exports.default = TextArea;
